import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IReleaseNote } from "../interfaces/arcus/ReleaseNote";
import { FormControl } from "@angular/forms";

interface DialogData {
    releaseNotes: IReleaseNote[];
    userOpened?: Boolean;
}

@Component({
    selector: "release-dialog",
    templateUrl: "./release-dialog.component.html",
    styleUrls: ["./release-dialog.component.scss"],
    standalone: false
})
export class ReleaseDialogComponent implements OnInit {
    releaseNotes: IReleaseNote[];
    mostRecentRelease: number = 0;
    compiledNotes: string = null;
    dontShowAgain: FormControl<boolean> = new FormControl(false);
    userOpened: Boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: DialogData,
        private dialogRef: MatDialogRef<ReleaseDialogComponent>
    ) {
        this.releaseNotes = data.releaseNotes;
        this.userOpened = data?.userOpened || false;
    }

    ngOnInit() {
        this.releaseNotes = this.releaseNotes.sort((first, second) => second.ID - first.ID);
        this.mostRecentRelease = this.releaseNotes[0].ID;
        this.compiledNotes = this.releaseNotes.map((r) => r.Content).join("<br>");
    }

    close() {
        this.dialogRef.close({ releaseNumber: this.mostRecentRelease, dontShowAgain: this.dontShowAgain.value });
    }
}
